module.exports = __webpack_public_path__ + "img/c1.0bf0860b.png";